import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D308 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D308 - Mobile Application Development (Android)</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 18.32 hrs</h4>
        <hr />
        <div className="card-body">
          <p>THE MOST FUN COURSE EVER.</p>
          <p>
            Okay, first of all, to summarize it—you are making a mobile
            application for Android in Android Studio using Java. You’re going
            to build this entire project from start to finish, and that’s what
            makes it so much fun.
          </p>
          <p>
            There’s a 4-part video project where an instructor builds a bicycle
            shop app. I actually followed these videos exactly. Just remember
            that her Product = Vacation and her Part = Excursion. Some of her
            code is a little complex and can be made easier, and you’ll notice
            this as you follow along. I had a few hiccups with the code, but I
            followed the videos, and there wasn’t anything I couldn’t figure out
            myself (I have no coding experience except for this degree).
          </p>
          <p>
            The only annoying part of this app is the layouts in Android Studio.
            It’s pretty finicky.
          </p>
          <p>
            Also, I finished my entire app first and then selected certain files
            to push to the repo. I didn’t even push the code in order. Like, my
            second commit was finishing Part C, and then my third commit was
            Part B, etc. (just an example).
          </p>
          <p>
            Oh, and this guide is what I used while following the instructor’s
            videos: 👉{" "}
            <a href="https://www.reddit.com/r/wgu_devs/comments/1bpexhf/d308_mobile_applications_android_updated_tips/" target="_blank" rel="noreferrer">
              D308 Mobile Applications (Android) - Updated Tips
            </a>
          </p>
          <p>
            TL;DR: Follow the instructor’s videos, swap out the terms, expect
            some layout headaches, and push commits however you want. This
            course is actually so much fun!
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D308;
